import React from "react";
import { useLoaderData } from "react-router-dom";
import UpgradePlanDialog from "./UpgradePlanDialog";

function UpgradePlanChecker() {
  const loaderData = useLoaderData() as {
    subscription?: { sameSubscription: boolean };
  };
  const [showDialog, setShowDialog] = React.useState(false);

  React.useEffect(() => {
    const needsUpgrade = !loaderData.subscription?.sameSubscription;
    if (needsUpgrade) {
      setShowDialog(true);
    }
  }, [loaderData.subscription?.sameSubscription]);

  return <UpgradePlanDialog open={showDialog} />;
}

export default UpgradePlanChecker;
